import React from 'react';

import image1 from '../assets/CampusImage/campus2.jpeg';
import image2 from '../assets/CampusImage/campus3.jpeg';
import image3 from '../assets/CampusImage/campus4.jpeg';
import image4 from '../assets/CampusImage/campus1.jpeg';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function CampusView() {
    const images = [image1, image2, image3, image4];

    return (
        <div className="container my-5">
            <div
                style={{
                    backgroundColor: "#77236b",
                    padding: "12px 40px",
                    borderRadius: "8px",
                    border: "1px solid #cdd6f3",
                    boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                    color: "#fff",
                    textAlign: "center",
                    width: "100%",
                    marginBottom: "2rem"
                }}
            >
                <h2 className="fw-bold m-0">परिसर दृश्य</h2>
            </div>
            <div className="row g-4">
                {images.map((img, index) => (
                    <div className="col-12" key={index}>
                        <div className="card shadow-lg border-0">
                            <img
                                src={img}
                                alt={`Campus ${index + 1}`}
                                className="card-img-top"
                                style={{
                                    height: '450px',
                                    objectFit: 'cover',
                                    borderRadius: '10px'
                                }}
                            />

                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
